var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuller6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4583 21.6666H54.9909C56.0315 21.6666 56.875 22.5102 56.875 23.5507V52.2826C56.875 53.3231 56.0315 54.1666 54.9909 54.1666H10.9511C9.39028 54.1666 8.125 52.9014 8.125 51.3406V13.6594C8.125 12.0986 9.39028 10.8333 10.9511 10.8333H49.5743C50.6148 10.8333 51.4583 11.6768 51.4583 12.7174V21.6666ZM51.4583 21.6666H18.9583",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.739 31.087H29.6738C27.8529 31.087 26.3767 32.5632 26.3767 34.3841V34.3841C26.3767 36.205 27.8529 37.6812 29.6738 37.6812H34.384C36.2049 37.6812 37.6811 39.1574 37.6811 40.9783V40.9783C37.6811 42.7992 36.2049 44.2754 34.384 44.2754H26.3767M32.0289 29.2029V46.1595",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuller6);
export default __webpack_public_path__ + "static/media/ruller6.fd7c7815c582a896dee1a64be0a329ca.svg";
export { ForwardRef as ReactComponent };